module.exports = __webpack_public_path__ + "static/media/snow.58d7aff3.ico";